import { state } from '@/store';

/**
 * Поле `game` из GET /api/main/settings — вычисляется бэком по датам START_GAME / END_GAME в конфиге.
 * Аналог `status` для акции: active | past | future.
 * Дополнительно поддерживаем START_GAME / END_GAME на случай прямой отдачи.
 */

/**
 * @param {unknown} game
 * @returns {'start'|'end'|'not-started'|''}
 */
export function mapGameStatusFromApi(game) {
  const s = String(game == null ? '' : game).trim().toLowerCase();
  if (!s) return '';

  if (s === 'active' || s === 'start' || s === 'start_game') return 'start';
  if (s === 'past' || s === 'end' || s === 'ended' || s === 'end_game') return 'end';
  if (s === 'future' || s === 'not-started' || s === 'not_started') return 'not-started';

  return '';
}

/**
 * @param {{ game?: unknown }|null|undefined} settings
 */
export function applyGameStatusFromMainSettings(settings) {
  const mapped = mapGameStatusFromApi(settings?.game);
  if (mapped) {
    state.gameStatus = mapped;
  }
}

export function isGamePlayAllowed() {
  return state.gameStatus === 'start';
}

export function getGamePlayBlockedLabel() {
  if (state.gameStatus === 'end') return 'Игры завершены';
  if (state.gameStatus === 'not-started') return 'Скоро';
  return 'Игра недоступна';
}
